<template>
    <div class="leftside-menu">

        <!-- Logo Light -->
        <a href="index.html" class="logo logo-light mt-1" style="background-color: black; z-index: 1000;">
            <span class="logo-lg">
                <img src="/assets/images/logo.png" alt="logo" style="height: 65px;">
            </span>
            <span class="logo-sm">
                <!-- <img src="/assets/images/logo.png" alt="small logo" style="height: 65px;"> -->
            </span>
        </a>

        <!-- Logo Dark -->
        <a href="index.html" class="logo logo-dark mt-1" style="background-color: black; z-index: 1000;">
            <span class="logo-lg">
                <img src="/assets/images/logo.png" alt="dark logo" style="height: 65px;">
            </span>
            <span class="logo-sm">
                <!-- <img src="/assets/images/logo.png" alt="small logo" style="height: 65px;"> -->
            </span>
        </a>


        <!-- Sidebar Hover Menu Toggle Button -->
        <button type="button" class="btn button-sm-hover p-0" data-bs-toggle="tooltip" data-bs-placement="right"
            title="Show Full Sidebar">
            <i class="ri-checkbox-blank-circle-line align-middle"></i>
        </button>

        <!-- Sidebar -left -->
        <div class="h-100" id="leftside-menu-container" data-simplebar>
            <!-- Leftbar User -->
            <div class="leftbar-user">
                <a href="pages-profile.html">
                    <img src="/assets/images/users/avatar-1.jpg" alt="user-image" height="42"
                        class="rounded-circle shadow-sm">
                    <span class="leftbar-user-name">Dominic Keller</span>
                </a>
            </div>

            <!--- Sidemenu -->
            <ul class="side-nav">

                <!-- <li class="side-nav-title side-nav-item">GENERAL</li> -->

                <!-- <MenuLateral :titulo="$t('menus.statistics')" icono="uil uil-analytics" url="/"/> -->

                <MenuLateral :titulo="$t('menus.settings')" icono="mdi mdi-cog" url="/configuracion"/>

                <!-- <MenuLateral :titulo="$t('menus.users',2)" icono="uil-users-alt" url="/usuarios" /> -->

                <MenuLateral :titulo="$t('menus.tasks',2)" icono="uil uil-clipboard-notes" url="/tareas" />


                <!-- <li class="side-nav-title side-nav-item">ERP</li> -->
                <MenuLateral :titulo="$t('menus.users', 2)" icono="uil-users-alt" url="/usuarios?page=1&step=5" />

                <MenuLateral :titulo="$t('menus.brands',2)" icono="uil-tag-alt " url="/marcas?page=1&step=5" />

                <MenuLateral :titulo="$t('menus.products',2)" icono="uil-box" url="/productos?page=1&step=5" />

                <!-- <MenuLateral :titulo="$t('menus.thirds')" icono="uil-user" :submenus="[
                    {id: 1, titulo: $t('menus.clients',2), url: '/clientes'},
                    {id: 2, titulo: $t('menus.providers'), url: '/terceros/proveedores'},
                    {id: 3, titulo: $t('menus.employees'), url: '#'},
                ]" />

                <MenuLateral :titulo="$t('menus.orders',2)" url="/pedidos" icono="uil uil-clipboard-notes"></MenuLateral> -->

                <li class="side-nav-title side-nav-item">E-COMMERCE</li>
                
                <!-- <MenuLateral :titulo="$t('menus.publications',2)" icono="uil uil-clipboard-notes" url="/publicaciones" /> -->

                <!-- <MenuLateral titulo="Tienda" icono="uil-store" :submenus="[
                    {id: 1, titulo: $t('menus.publications',2), url: '/tienda/publicaciones'},
                    {id: 2, titulo: $t('menus.questions'), url: '/tienda/preguntas'},
                    {id: 3, titulo: $t('menus.sales'), url: '/tienda/ventas'},
                    {id: 4, titulo: $t('menus.payments'), url: '/tienda/pagos'},
                    {id: 5, titulo: $t('menus.refunds'), url: '/tienda/devoluciones'},
                ]" /> -->

                <!-- <MenuLateral titulo="Any Market" imagen="/assets/images/anymarket_logo.jpg" :submenus="[
                    {id: 6, titulo: $t('menus.upload'), url: '/anymarket/uploaded'},
                    {id: 2, titulo: $t('menus.trasmission'), url: '/anymarket/transmissions'},
                    // {id: 3, titulo: $t('menus.questions'), url: '/anymarket/preguntas'},
                    {id: 4, titulo: $t('menus.sales'), url: '/anymarket/ventas'},
                    // {id: 6, titulo: $t('menus.refunds'), url: '/anymarket/devoluciones'},
                ]" /> -->

                <MenuLateral titulo="Mercado Libre" imagen="/assets/images/ml-logo.png" :submenus="[
                    {id: 1, titulo: $t('menus.publications',2), url: '/mercadolibre/publicaciones'},
                    {id: 2, titulo: $t('menus.questions'), url: '/mercadolibre/preguntas'},
                    {id: 3, titulo: $t('menus.sales'), url: '/mercadolibre/ventas'},
                    {id: 4, titulo: $t('menus.payments'), url: '/mercadolibre/pagos'},
                    {id: 5, titulo: $t('menus.refunds'), url: '/mercadolibre/devoluciones'},
                ]" />

                <!-- <MenuLateral titulo="Amazon" imagen="/assets/images/amazon-logo-light.svg" :submenus="[
                    {id: 1, titulo: $t('menus.publications',2), url: '/amazon/publicaciones'},
                    {id: 2, titulo: $t('menus.questions',2), url: '/amazon/preguntas'},
                    {id: 3, titulo: $t('menus.sales'), url: '/amazon/ventas'},
                    {id: 4, titulo: $t('menus.payments'), url: '/amazon/pagos'},
                    {id: 5, titulo: $t('menus.refunds'), url: '/amazon/devoluciones'},

                ]" /> -->

              <!-- <MenuLateral titulo="Walmart" imagen="/assets/images/walmart-logo.png" :submenus="[
                    {id: 1, titulo: $t('menus.publications',2), url: '/walmart/publicaciones'},
                    {id: 3, titulo: $t('menus.sales'), url: '/walmart/ventas'},
                    {id: 5, titulo: $t('menus.refunds'), url: '/walmart/devoluciones'}
                    
                  /*  {id: 2, titulo: $t('menus.questions',2), url: '/walmart/preguntas'},
                    {id: 4, titulo: $t('menus.payments'), url: '/walmart/pagos'},
                   ,*/

                ]" /> -->

                <!-- <MenuLateral titulo="Linio" icono="uil-store" :submenus="[
                    {id: 1, titulo: $t('menus.questions',2), url: '/amazon/preguntas'},
                    {id: 2, titulo: $t('menus.sales'), url: '/amazon/ventas'},
                    {id: 3, titulo: $t('menus.payments'), url: '/amazon/pagos'},
                    {id: 4, titulo: $t('menus.refunds'), url: '/amazon/devoluciones'},

                ]" /> -->

                <!-- <MenuLateral titulo="Claro Shop" icono="uil-store" :submenus="[
                    {id: 1, titulo: $t('menus.questions',2), url: '/amazon/preguntas'},
                    {id: 2, titulo: $t('menus.sales'), url: '/amazon/ventas'},
                    {id: 3, titulo: $t('menus.payments'), url: '/amazon/pagos'},
                    {id: 4, titulo: $t('menus.refunds'), url: '/amazon/devoluciones'},

                ]" /> -->

            </ul>
            <!--- End Sidemenu -->


            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script setup>
import MenuLateral from './MenuLateral.vue';

</script>
